import React from 'react';
import { Sparkles } from 'lucide-react';
import { useWorkspace } from '../context/WorkspaceContext';
import { cn } from '../lib/utils';

export default function PlanBadge({ className }) {
  const { plan, planLabel, openProDialog, selectedWorkspace } = useWorkspace();
  if (!selectedWorkspace) return null;
  const isPro = plan === 'pro';
  return (
    <button
      type="button"
      onClick={isPro ? undefined : openProDialog}
      data-testid="plan-badge"
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium border transition-colors',
        isPro
          ? 'bg-[#00E05E]/10 text-[#00E05E] border-[#00E05E]/30 cursor-default'
          : 'bg-zinc-800 text-zinc-400 border-zinc-700 hover:text-white hover:border-zinc-500',
        className
      )}
      title={isPro ? 'Pro plan' : 'Free plan — click to see Pro'}
    >
      {isPro && <Sparkles className="w-3 h-3" />}
      {isPro ? planLabel : `${planLabel} plan · Upgrade`}
    </button>
  );
}
